import global from "@/locales/sr-RS/global";
import error403 from "@/locales/sr-RS/errors/403";
import error404 from "@/locales/sr-RS/errors/404";
import error500 from "@/locales/sr-RS/errors/500";
import error503 from "@/locales/sr-RS/errors/503";
import error504 from "@/locales/sr-RS/errors/504";
import maintenance from "@/locales/sr-RS/auth/maintenance";
import toast from "@/locales/sr-RS/toast/toast";
import login from "@/locales/sr-RS/auth/login";
import onboarding from "@/locales/sr-RS/auth/onboarding";
import loginPageSteps from "@/locales/sr-RS/loginPageSteps";
import dashboard from "@/locales/sr-RS/dashboard/dashboard";
import account from "@/locales/sr-RS/account/account";
import mailbox from "@/locales/sr-RS/account/mailbox";
import bankstatement from "@/locales/sr-RS/account/bankstatement";
import myApps from "@/locales/sr-RS/my-apps/myApps";
import about from "@/locales/sr-RS/about/about";
import contactService from "@/locales/sr-RS/about/contactService";
import salesPromotions from "@/locales/sr-RS/sales/promotions";
import brochures from "@/locales/sr-RS/sales/brochures";
import shop from "@/locales/sr-RS/shop/data";
import priceList from "@/locales/sr-RS/shop/priceList";
import staff from "@/locales/sr-RS/dashboard/staff";
import promotions from "@/locales/sr-RS/promotions";
import points from "@/locales/sr-RS/points";
import trainings from "@/locales/sr-RS/trainings/trainings";
import vouchers from "@/locales/sr-RS/vouchers/vouchers";
import media from "@/locales/sr-RS/media/index";
import product from "@/locales/sr-RS/product/index";
import message from "@/locales/sr-RS/message/index";
import commitmentLetter from "@/locales/sr-RS/account/commitmentLetter";
import multiplicator from "@/locales/sr-RS/multiplicator";
import consents from "@/locales/sr-RS/consents/consents";
import investment from "@/locales/sr-RS/investment/data";
import kickback from "@/locales/sr-RS/kickback";
//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Slike proizvoda",
    BDriveLinkText: "Link ka portalu SLIKA PROIZVODA",
  },
}

export default {
  locale: "sr-RS",
  messages,
};
